/**
 * Slug parsing for hosted careers pages (TEC-488) — the careers twin of
 * utils/company/resolve-company-profile-route-slug.ts, with the same slashes-in-company-name
 * guard: the CDN pre-decodes %2F, so a company like "Astellas Pharma A/S, filial i Finland"
 * arrives as extra path segments that must be rejoined into one slug.
 */
import { LOCALIZED_PATHS } from '../constants/url-constants';

function safeDecodeSegment(segment: string): string {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}

/** Parses `/careers/:slug(+)`, `/en/careers/…`, `/fi/ura/…`, `/sv/karriar/…` into the slug. */
export function extractCareersSlugFromUrlPathname(pathname: string): string | null {
  if (!pathname || pathname === '/') return null;
  const pathOnly = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  const parts = pathOnly.split('/').filter(Boolean);
  if (parts.length < 2) return null;

  const enCareersSeg = LOCALIZED_PATHS.en.careers;

  if (parts[0] === enCareersSeg) {
    const slug = parts
      .slice(1)
      .map((p) => safeDecodeSegment(p))
      .join('/');
    return slug.trim() !== '' ? slug : null;
  }

  if (parts.length >= 3) {
    const loc = parts[0];
    if (loc !== 'en' && loc !== 'fi' && loc !== 'sv') return null;
    const careersSeg = LOCALIZED_PATHS[loc].careers;
    if (parts[1] !== careersSeg) return null;
    const slug = parts
      .slice(2)
      .map((p) => safeDecodeSegment(p))
      .join('/');
    return slug.trim() !== '' ? slug : null;
  }

  return null;
}
